<template>
    <div>
        <h4>Vue Chapter 2</h4>
        <p>テスト用、、、。</p>
    </div>
</template>

<script>
    export default{
        name: 'VueChapter2',
    }
</script>